import { useCallback } from "react"
import { observer } from "mobx-react"
import { useStore } from "@features/common"
import classnames from "classnames"

import { SubscriptionDialog } from "./subscription-dialog"
import { SubscriptionForm } from "./subscription-form"

interface SubscriptionProps {
  className?: string
}

export const Subscription = observer(function Subscription(
  props: SubscriptionProps,
) {
  const { GlobalModel, ModalModel, AnalyticsModel } = useStore()
  const { className } = props
  const { journalFooterForm, datingFooterForm } =
    GlobalModel.featureToggles.emailSubscription || {}
  let enableFooter: boolean | undefined = false

  if (GlobalModel.isPureDating) {
    enableFooter = datingFooterForm
  } else {
    enableFooter = journalFooterForm
  }

  const submitCallback = useCallback(
    function submitCallback() {
      ModalModel.open(<SubscriptionDialog success={true} />)
      AnalyticsModel.subscribeFooterSubmitClick()
    },
    [ModalModel, AnalyticsModel],
  )

  if (!enableFooter) {
    return null
  }

  return (
    <section
      className={classnames("container py-12.5 tablet:py-20", className)}
    >
      <div className="flex justify-center">
        <SubscriptionForm
          classes={{
            title: "text-xl desktop:text-2xl",
          }}
          onSubmit={submitCallback}
        />
      </div>
    </section>
  )
})
